// @flow

import ElementPortal from 'react-element-portal';
import React, { Component } from 'react';

import HomepageServiceSearch from 'app/homepage/components/HomepageServiceSearch';
import trackNewHomepageEvents from 'app/homepagev2/scripts/Container';

import type { Service as ServiceType } from 'app/service/types';

type AppProps = {
  serviceSearch: {
    query: string,
    selectedService: ServiceType,
  },
  matchedServices: Array<ServiceType>,
  defaultServices: Array<ServiceType>,
  updateAppSearchQuery: (query: string) => void,
  changeAppSearchService: (service: ServiceType) => void,
};

class App extends Component<AppProps> {
  static defaultProps = {
    defaultServices: [],
  };

  componentDidMount() {
    /**
     * The new homepage needs to add tracking to its CTAs, but there's no way to load the tracking
     * script when we load the new homepage because it shares the same route as the old homepage.
     * Both, the old and new homepage load in `/`
     *
     * This should not affect the old homepage current functionality.
     */
    trackNewHomepageEvents();
  }

  remotelyRenderElementIfContainerExists = (
    containerId: string,
    renderer: () => {}
  ) => {
    return !document.getElementById(containerId) ? null : (
      <ElementPortal id={containerId}>{renderer()}</ElementPortal>
    );
  };

  renderAppSearch = () => (
    <HomepageServiceSearch
      defaultServices={this.props.defaultServices}
      matchedServices={this.props.matchedServices}
      query={this.props.serviceSearch.query}
      selectedService={this.props.serviceSearch.selectedService}
      selectService={this.props.changeAppSearchService}
      updateAppSearchQuery={this.props.updateAppSearchQuery}
    />
  );

  render() {
    return (
      <div>
        {this.remotelyRenderElementIfContainerExists(
          'homepage-app-search',
          this.renderAppSearch
        )}
      </div>
    );
  }
}

export default App;
